import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, headerColor, time } from "@clockwise/web-commons/src/styles/color.styles";
import { weight } from "@clockwise/web-commons/src/styles/type.styles";

//////////////////
// SETUP
//////////////////
const containerWidth = 255;
const containerHeight = 130;
export const avatarWidth = 50;

//////////////////
// TEAM VIEW
//////////////////
export const container: CSSProperties = {
  position: "relative",
  height: containerHeight,
};

export const loading: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  height: containerHeight,
};

export const header: CSSProperties = {
  display: "flex",
  alignItems: "center",
  paddingTop: 15,
  fontSize: 14,
  paddingBottom: 2,
};

export const headerLabel: CSSProperties = {
  color: headerColor,
  fontWeight: weight.bold,
  marginRight: "auto",
};

export const legend: CSSProperties = {
  display: "flex",
  alignItems: "center",
  fontSize: 12,
  color: greys.slate,
};

const legendDot: CSSProperties = {
  borderRadius: "50%",
  height: 10,
  width: 10,
  marginRight: 5,
};

export const legendFocusDot: CSSProperties = {
  ...legendDot,
  backgroundColor: time.focus,
};

export const legendBusyDot: CSSProperties = {
  ...legendDot,
  marginLeft: 10,
  backgroundColor: time.busy,
};

export const divider: CSSProperties = {
  width: "100%",
  borderBottom: `1px solid ${greys.cloudyBlue}`,
  position: "absolute",
  bottom: 0,
};

//////////////////
// TEAM SCROLLER
//////////////////
// fancy css to allow for a flexible width container that shows
// exactly 4 items, but allows overflow to scroll to more
export const teamContainer: CSSProperties = {
  paddingTop: 15,
  position: "absolute",
  left: -10, // pull the left/right buttons out to the edges of the extension
  right: 0,
  display: "flex",
  alignItems: "center",
};

export const scrollContainer: CSSProperties = {
  padding: 0,
  width: 20,
  flexShrink: 0,
};

export const teamScrollContainer: CSSProperties = {
  maxWidth: "100%",
  overflow: "hidden",
};

export const teamsScroll: CSSProperties = {
  maxHeight: avatarWidth + 20,
  width: 100000, // allow to overflow as much as needed
  display: "flex",
};

export const getScrollColor = (hovered: boolean) => {
  return hovered ? greys.standard : greys.blueGrey;
};

export const teamSet: CSSProperties = {
  width: containerWidth - 30,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  transition: "margin-left .4s",
};

export const teammateContainer: CSSProperties = {
  display: "inline-block",
  height: "100%",
};
